/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export type IncidentsMode = (typeof IncidentsMode)[keyof typeof IncidentsMode];

export const IncidentsMode = {
  REPORT: 'report',
  API: 'api',
} as const;
